import useFeatures from "../../hooks/useRedFlag";
import { useAuth } from "../../context/authContext";
import GlassCard from "../ui/GlassCard";
import ProgressBar from "../ui/ProgressBar";
import LoadingState from "../ui/LoadingState";
const Alert = ({ name }) => {
  const { code } = useAuth();
  const { features, loading, error } = useFeatures(code);
  // console.log("feature, loading " ,features, loading)
  return (
    <GlassCard accent="magenta" className="flex flex-col gap-4 text-slate-900 dark:text-white">
      <h1 className="font-['Space_Grotesk',_sans-serif] text-[22px] font-semibold">{name}</h1>
      {loading && <LoadingState rows={4} />}
      {!loading && (error || !features?.redFlagAttacks) && (
        <p className="text-sm text-slate-400 dark:text-white/40">No red flag data available yet.</p>
      )}
      {!loading && !error && features?.redFlagAttacks && (
        <div className="flex flex-row items-start flex-wrap gap-x-8 gap-y-4">
          {Object.entries(features.redFlagAttacks.labelCounts).map(([label, count]) => {
            const { totalCount, totalUsers } = features.redFlagAttacks;
            const percentage = totalCount ? Number((count / totalCount * 100).toFixed(0)) : 0;
             const value2 = `${count}/${totalCount}` ??0;
            return <ProgressBar key={label} label={label} value={percentage} value2={value2} number={true} color="#FF5C7A" />;
          })}
        </div>
      )}
    </GlassCard>
  );
};
var Alert_default = Alert;
export { Alert_default as default };